import React from 'react';

const TiktokOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.246 1.54c.597-.009 1.19-.004 1.782-.009.037.698.287 1.408.798 1.9.51.506 1.23.739 1.932.816v1.837a4.9 4.9 0 0 1-1.914-.442 6 6 0 0 1-.738-.424c-.005 1.33.004 2.661-.01 3.988A3.5 3.5 0 0 1 8.481 11a3.4 3.4 0 0 1-2.693 1.463 3.3 3.3 0 0 1-1.86-.47c-.92-.542-1.567-1.535-1.663-2.602a9 9 0 0 1-.004-.679 3.42 3.42 0 0 1 1.176-2.26c.756-.656 1.813-.97 2.802-.784.01.675-.018 1.35-.018 2.024-.451-.146-.98-.105-1.376.168a1.6 1.6 0 0 0-.62.798c-.096.232-.068.487-.064.733.11.748.83 1.377 1.595 1.308.51-.004.998-.3 1.262-.733.087-.15.183-.306.187-.483.046-.816.028-1.627.032-2.443.005-1.837-.004-3.669.01-5.5"
            fill="#fff"
        />
    </svg>
);
export default TiktokOutlined;
